import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/Library/Icon";

import styles from "./NotFound.css";

export default function NotFound() {
  return React.createElement(
    "div",
    { className: styles.root },
    React.createElement(Icon, { name: "confused-person", description: "Confused person image", path: "img", className: styles.icon }),
    React.createElement(
      "div",
      { className: styles.description },
      "404! In other words, something went wrong."
    ),
    React.createElement(
      Link,
      { to: "/", className: styles.button },
      "Read top stories"
    )
  );
}


// WEBPACK FOOTER //
// ./src/dashboard/components/NotFound/NotFound.js